import { Injectable, TemplateRef, signal } from '@angular/core';
import { Subject } from 'rxjs';

export interface DialogConfig {
  type: 'dialog';
  icon: string;
  title: string;
  description: string;
  buttonCancelLabel: string;
  buttonConfirmLabel: string;
  variant: 'info' | 'negative';
  closeButton?: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
}

export interface FullscreenConfig {
  type: 'fullscreen';
  template: TemplateRef<unknown>;
}

export type ModalConfig = DialogConfig | FullscreenConfig;

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  public modalConfig = signal<ModalConfig | null>(null);
  private openSubject = new Subject<void>();
  private closeSubject = new Subject<void>();

  public opened$ = this.openSubject.asObservable();
  public closed$ = this.closeSubject.asObservable();

  public open(config: ModalConfig) {
    this.modalConfig.set(config);
    this.openSubject.next();
  }

  public close() {
    this.modalConfig.set(null);
    this.closeSubject.next();
  }
}
